import React from 'react';
import { useTranslation } from 'react-i18next';

import { Colors, Icons } from '@kp/react-ui';

import type { AppAccess } from '../../types/home-types';
import { InstalledAppCard } from '../InstalledAppCard';

export type TwinStudioAppCardProps = AppAccess;

export const TwinStudioAppCard: React.FC<TwinStudioAppCardProps> = (access) => {
  const { t } = useTranslation();

  return (
    <InstalledAppCard
      icon={Icons.IconDashboard}
      iconColor={Colors.Palette.green}
      title={t('home.apps.twinStudio.title')}
      description={t('products.commissioning.description')}
      {...access}
    />
  );
};
